import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Strona główna anonimowego czatu ${ctx.brand}`,
    languageButtonLabel: `Język`,
    languageModalTitle: `Wybierz język`,
    languageModalCloseLabel: `Zamknij menu języków`,
  },
  languageOptions: {
    'en-US': {
      label: `Angielski (Stany Zjednoczone)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Angielski (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Angielski (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Angielski (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugalski (Portugalia)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugalski (Brazylia)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Niemiecki (Niemcy)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Niemiecki (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Niemiecki (Szwajcaria)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Hiszpański (Hiszpania)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francuski (Francja)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Włoski (Włochy)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Niderlandzki (Holandia)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski (Polska)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Szwedzki (Szwecja)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Duński (Dania)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Fiński (Finlandia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norweski (Norwegia)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandzki (Islandia)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japoński (Japonia)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreański (Korea Południowa)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chiński (Chiny)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantoński (SRA Hongkong (Chiny))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Wietnamski (Wietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tajski (Tajlandia)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonezyjski (Indonezja)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Suahili (Kenia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Indie)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalski (Bangladesz)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (Indie)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Indie)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Perski (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Pendżabski (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidżyn nigeryjski (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Rosyjski (Rosja)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabski (Arabia Saudyjska)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabski (Zjednoczone Emiraty Arabskie)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabski (Katar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokański arabski (Maroko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turecki (Turcja)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Wybierz język`,
    closeLabel: `Zamknij menu języków`,
  },
  languageHint: (ctx) => `Przeskakuj między ${ctx.localesCount}+ wersjami językowymi bez zakładania konta.`,
  readPagePrompt: ({languageLabel}) => `Przeczytaj tę stronę w języku ${languageLabel}.`,
};
